// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".outer-slider-style[data-v-45c44af6] {\n  background-color: #fff;\n}\n.slider-style[data-v-45c44af6] {\n  padding: 20px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: #fff;\n  vertical-align: middle;\n}\n", ""]);
// Exports
module.exports = exports;
